import React, { useContext } from 'react'
import { Loading } from '@guillotinaweb/react-gmi'
import { Button } from '@guillotinaweb/react-gmi'
import { ErpClientContext } from '../../services/erp'
import { Select } from '@guillotinaweb/react-gmi'
import * as dayjs from 'dayjs'
import { message } from 'antd'
import 'antd/dist/antd.css'
import { linkOrder } from './common'
import { linkBackoffice } from './common'
import { Modal } from 'antd'

const day = (val) => dayjs(val).format('DD/MM/YYYY')

const getKind = (row) => {
  if (row.id_prov_vino === 'ago') {
    return 'agotado'
  }
  if (row.id_prov_vino === 'cam') {
    return 'anada'
  }
  return 'delay'
}

export const groupOrders = (data) => {
  const orders = {}
  for (let i = 0; i < data.length; i++) {
    let id_ = data[i].cod_pedido
    if (!orders[id_]) {
      orders[id_] = []
    }
    orders[id_].push(data[i])
  }
  return orders
}

const SITES = [
  { text: 'Vinissimus', value: 'vinissimus' },
  { text: 'Italvinus', value: 'italvinus' },
  { text: 'Francevinus', value: 'fr' },
  { text: 'De', value: 'de' },
  { text: 'Uk', value: 'uk' },
]

const removeKey = (prop, elements) =>
  Object.keys(elements).reduce((object, key) => {
    if (key !== prop) {
      object[key] = elements[key]
    }
    return object
  }, {})

export function DelayedOrders() {
  const erpService = useContext(ErpClientContext)
  const [data, setData] = React.useState(undefined)
  const [site, setSite] = React.useState('vinissimus')

  const processOrder = (cod_pedido, orders) => {
    console.log(`Process ${cod_pedido} orders`, orders)
    setData(removeKey(cod_pedido, orders))
  }

  React.useEffect(() => {
    ;(async () => {
      setData(undefined)
      const resp = await erpService.get('/orders/@delayed-orders', site)
      if (resp.status === 200) {
        const d = await resp.json()
        setData(groupOrders(d))
      }
    })()
  }, [site])

  return (
    <div
      className="container"
      style={{ backgroundColor: '#fff', padding: '30px' }}
    >
      <div className="level">
        <div className="level-left">
          <h2 className="title is-size-5">
            Delayed Orders ({data && Object.keys(data).length})
          </h2>
        </div>
        <div className="level-right is-size-7">
          <Select
            onChange={(e) => setSite(e.target.value)}
            options={SITES}
            value={site}
          />
        </div>
      </div>

      {!data && <Loading />}
      {data && (
        <>
          <table className="ventas table is-bordered is-striped is-fullwidth is-size-7">
            <thead>
              <tr>
                <th>Product</th>
                <th>Fecha Pedido</th>
                <th>Fecha Recepción</th>
                <th>Prov</th>
                <th>Qty. Pedido</th>
                <th>Disponible</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(data).map((ped) => (
                <React.Fragment key={'header' + ped}>
                  <tr style={getStyle(data[ped][0])} key={'ped' + ped}>
                    <td colSpan="5">
                      <a
                        href={linkOrder([site], data[ped][0].id_pedido)}
                        target="_pedido"
                      >
                        <strong style={{ color: '#000' }}>{ped}</strong>
                      </a>
                      &nbsp;
                      <a
                        href={linkBackoffice(
                          site,
                          LinkUsuario(data[ped][0].id_usuario)
                        )}
                        target="_blank"
                        style={{ color: '#666' }}
                      >
                        {data[ped][0].email}
                      </a>
                      &nbsp; Inci: {data[ped][0].incidencia}
                    </td>
                    <td>{data[ped][0].precio_total}&euro;</td>
                    <td>
                      <a
                        href={linkBackoffice(
                          site,
                          LinkUsuario(data[ped][0].id_usuario)
                        )}
                        target="_blank"
                      >
                        {data[ped][0].id_usuario}
                      </a>{' '}
                      - {data[ped][0].clasificacion}
                    </td>
                  </tr>
                  {data[ped].map((row) => (
                    <tr key={`${row.id_pedido}_${row.id_producto}`} style={{}}>
                      <td>
                        <a
                          href={linkBackoffice(
                            site,
                            '/administracion/contenidos/edicion_producto.html?id_producto=' +
                              row.id_producto
                          )}
                          target="_pedido"
                        >
                          {row.id_producto}
                        </a>
                        &nbsp;
                        <InfoReservas row={row} site={site} />
                        <br />
                        {row.nombre}
                      </td>
                      <td>{day(row.fecha_stock)}</td>
                      <td>{day(row.fecha)}</td>
                      <td>{row.id_prov_vino}</td>
                      <td>{row.ccompra}</td>
                      <td>{row.stock_real + '/' + row.sum2}</td>
                      <td>
                        <ActionButtons
                          row={[row]}
                          order={data[ped]}
                          site={site}
                          onProcess={(order) => processOrder(order, data)}
                        />
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  )
}

const getStyle = (row) => {
  let kind = getKind(row)
  const styles = {
    anada: '#a5dede',
    agotado: '#dea5a5',
    delay: '#DDD',
  }
  return {
    backgroundColor: styles[kind],
  }
}

const LinkReservas = (id_, site) => {
  const sites = {
    vinissimus: 'cas',
    italvinus: 'tr2',
    fr: 'clr',
  }
  return `/administracion/pedidos/prod_informacion_reservas.html?id_almacen=${sites[site]}&id_producto=${id_}`
}

const LinkUsuario = (user) => {
  return `/administracion/usuarios/ficha_usuario.html?id_usuario=${user}`
}

const InfoReservas = ({ row, site }) => {
  const [show, setShow] = React.useState(false)
  return (
    <span className="tag">
      <a
        href={linkBackoffice(site, LinkReservas(row.id_producto, site))}
        target="_pedido"
      >
        Info Reservas
      </a>{' '}
      &nbsp;
      <a onClick={(e) => setShow(true)}>Show</a>
      {show && (
        <Modal
          title="Basic Modal"
          title="Stock Bookings"
          visible={show}
          onOk={(ev) => setShow(false)}
          onCancel={(ev) => setShow(false)}
        >
          <ReservasProducto id_producto={row.id_producto} site={site} />
        </Modal>
      )}
    </span>
  )
}

const ReservasProducto = ({ site, id_producto }) => {
  const erpService = useContext(ErpClientContext)
  const [loading, setLoading] = React.useState(true)
  const [data, setData] = React.useState([])

  React.useEffect(() => {
    ;(async () => {
      const url = `/orders/@stocks?id_producto=${id_producto}&shop=${site}`
      const resp = await erpService.get(url)
      if (resp.status === 200) {
        const d = await resp.json()
        setData(d)
      }
      setLoading(false)
    })()
  }, [])

  return (
    <>
      {loading && <Loading />}
      {!loading && (
        <table className="ventas table is-bordered is-striped is-fullwidth is-size-7">
          <thead>
            <tr>
              <th>Pedido</th>
              <th>id_producto</th>
              <th>dsp</th>
              <th>res</th>
              <th>stock real</th>
              <th>qty.order</th>
              <th>stock_agg</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 &&
              data.map((item) => (
                <tr key={item.id_linea_pedido}>
                  <td>
                    <a href={linkOrder([site], item.id_pedido)} target="_blank">
                      {item.cod_pedido}
                    </a>
                  </td>
                  <td>{item.id_producto}</td>
                  <td>{item.dsp}</td>
                  <td>{item.res}</td>
                  <td>{item.stock_real}</td>
                  <td>{item.cantidad_pedido}</td>
                  <td>{item.stock_agg}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </>
  )
}

const sites = {
  vinissimus: 'V',
  italvinus: 'I',
  fr: 'F',
  de: 'D',
  uk: 'U',
}

const getOrderUrl = (item, site) => {
  return `/orders/${sites[site]}${item.id_pedido}/`
}

const ActionButtons = ({ row, onProcess, order, site = 'vinissimus' }) => {
  const erpService = useContext(ErpClientContext)
  const [loading, setLoading] = React.useState(false)

  const kind = getKind(row[0])

  const actions = {
    anada: async () => {
      setLoading(true)
      const url = `${getOrderUrl(row[0], site)}@change-vintage`
      const resp = await erpService.request(url, 'post', {
        referencia: row[0].id_producto,
      })
      if (resp.status === 200) {
        message.success(`Order ${row[0].cod_pedido} completed!`)
        onProcess(row[0].cod_pedido)
      } else {
        const error = await resp.json()
        message.error(
          `Error processing ${row[0].cod_pedido}: ${JSON.stringify(error)}`,
          20
        )
        // onFailed(row[0].cod_pedido, error)
      }
      setLoading(false)
    },
    agotado: async () => {
      setLoading(true)
      const url = `${getOrderUrl(row[0], site)}@update-na`
      const resp = await erpService.request(url, 'post', {
        referencia: row[0].id_producto,
      })
      if (resp.status === 200) {
        message.success(`Order ${row[0].cod_pedido} completed!`)
        onProcess(row[0].cod_pedido)
      } else {
        const error = await resp.json()
        message.error(
          `Error processing ${row[0].cod_pedido}: ${JSON.stringify(error)}`,
          20
        )
        // onFailed(row[0].cod_pedido, error)
      }
      setLoading(false)
    },
    delay: async () => {
      const data = getDelaiedProducts(order)
      setLoading(true)
      const url = `${getOrderUrl(row[0], site)}@notify-delay`
      const resp = await erpService.request(url, 'post', data)
      if (resp.status === 200) {
        message.success(`Order ${row[0].cod_pedido} notified!`)
        onProcess(row[0].cod_pedido)
      } else {
        const error = await resp.json()
        message.error(
          `Error processing ${row[0].cod_pedido}: ${JSON.stringify(error)}`,
          20
        )
        // onFailed(row[0].cod_pedido, error)
      }
      setLoading(false)
    },
  }

  const processAction = (current) => async (ev) => {
    if (actions[current]) {
      await actions[current]()
    }
  }

  let css = 'is-info'
  if (kind === 'agotado') css = 'is-danger'
  if (kind === 'delay') css = 'is-warning'

  // if (kind === 'agotado') return null

  return (
    <Button
      className={`button is-small ${css}`}
      onClick={processAction(kind)}
      loading={loading}
    >
      Notify {kind}
    </Button>
  )
}

const to_date = (val) => dayjs(val).format('YYYY-MM-DD')

const getDelaiedProducts = (order) => {
  let products = []
  order.map((row) => {
    if (getKind(row) === 'delay') {
      products.push({
        id_producto: row.id_producto,
        available: to_date(row.fecha),
      })
    }
  })
  return {
    products,
  }
}

/*
{
  "products": [
    {"id_producto": "lajmo18", "available": "2020-03-27"}
  ]
}
*/
